//@flow
import _ from 'lodash';
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import { objectsConstants, objectsEnuns } from '../../_constants/objects.constants';
import { formatterHelper } from '../../_helpers/formatter.helper';
import { empresaFinanceiroService } from '../../_services/empresaFinanceiro.service';
import FormSelectInput from '../../components/inputs/FormSelectInput';
import SelectInput from '../../components/inputs/SelectInput';
import FormInput from './../../components/inputs/FormInput';

type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class EstabelecimentoFinanceiroListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    return (
      <React.Fragment>
        <FormGroup className="col-12 col-xl-4">
          <FormInput
            label="Nome do estabelecimento"
            placeholder={'Nome'}
            id={'namefilter'}
            name="nome"
            onChange={this.props.onChangeDate}
            type={'text'}
            size={12}
            value={entity.nome}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-4">
          <FormSelectInput
            onChange={this.props.onChangeDate}
            id="empresa"
            label="Empresa"
            placeholder="Empresa"
            name="empresa"
            value={entity.empresa}
            returnFullObject={true}
            service={empresaFinanceiroService.findAll}
            creatable={false}
            isMulti={false}
            valueKey="id"
            labelKey="nome"
          />
        </FormGroup>
        <FormGroup className="col-12 col-lg-2">
          <SelectInput
            options={objectsEnuns.STATUS}
            label="Status"
            id="status"
            name="status"
            valueKey="name"
            labelKey="description"
            returnFullObject={true}
            value={_.get(entity, 'status')}
            placeholder="Status do estabelecimento"
            defaultValue={_.get(entity, 'status.description')}
            onChange={(name, value) => {
              this.props.onChangeDate(name, value)
            }}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-2">
          <SelectInput
            id={'bloqueadoFencom'}
            options={[
              { label: 'Sim', value: true },
              { label: 'Não', value: false },
            ]}
            returnFullObject={true}
            label="Bloqueio Fencom?"
            labelKey={'label'}
            valueKey={'value'}
            name={'bloqueadoFencom'}
            value={
              _.isBoolean(entity.bloqueadoFencom)
                ? formatterHelper.getEnum(
                  entity.bloqueadoFencom,
                  objectsConstants.SIM_NAO
                )
                : entity.bloqueadoFencom
            }
            onChange={(name, value) => {
              this.props.onChangeDate(name, value.value)
            }
            }
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
